import { GridCellProps } from '@progress/kendo-react-grid';
import { FC, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { warningIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const GlCodeTotal: FC<GridCellProps> = (props) => {
  const warnings = useContextSelector(InvoiceContext, (value) => value.warnings.totalCostAmt);
  const { dataItem } = props;
  const { displayValue } = useGridCellDisplayValue(props);
  const isTotals = useMemo(() => dataItem?.rowId === 'noExpand', [dataItem?.rowId]);
  const hasWarning = useMemo(() => isTotals && !!warnings.length, [warnings.length, isTotals]);

  return (
    <GridCellBase
      {...props}
      title={hasWarning ? warnings.join(', ') : displayValue}
      className={`${hasWarning && 'bg-warning bg-opacity-25'}`}
    >
      <div className={`${isTotals && 'font-bold  flex justify-end items-center'} text-right`}>
        {hasWarning && warningIcon}
        {displayValue}
      </div>
    </GridCellBase>
  );
};

export default GlCodeTotal;
